import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import Loader from "../../../utils/Loader";
import { getExhibitorSeminarDetails_action, insertUpdateExhibitorSeminar_action, getExhSeminarBadgeList_action } from "../../../actions/exhibitor_module_actions/exhibitorSeminar_action/exhibitorSeminar_action";
import { toastError, seminarInterestActionId, toastSuccess } from "../../../utils/constants";
import { data } from "jquery";
import moment from "moment";
import { fill_action } from "../../../actions/fillCombo_action";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import Modal from "react-modal";
const { Component } = require("react");
class ExhibitorSeminar extends Component {

    // Intialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            SeminarList: [],
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            HTMLEDITOR: false,
            HtmlContent: '',
            isOpenConfirmationModal: false,
            badgeList: [],
            badgeModalOpen: false,
            seminarId: '',
        }
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.insertUpdateExhibitorSeminar()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    // On componet Load
    componentDidMount() {
        this.getFillList(seminarInterestActionId, '', '', '1', '');
        setTimeout(() => {
            this.getExhibitorSeminarDetails()
            this.getBadgeList()
        }, 1000);
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value) {
        const { isAdd } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === seminarInterestActionId) {
                        data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                        data.data.length > 0 && data.data.map((item) => {
                            if (item.ParentSeminarID != null) {
                                item.Day = ''
                            }
                            item.selectedBadges = []
                        })
                        const result = this.calculateRowspan(data.data);
                        console.log("Visitor Interest List 121212", result)
                        this.setState({
                            SeminarList: result,
                        })
                        this.setState({
                            // SeminarList: data.data,
                            isLoading: false
                        })

                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    calculateRowspan(data) {
        // Create a map to count children for each parent seminar
        const parentChildMap = {};

        // Initialize Rowspan for each item and count the children
        data.forEach(item => {
            item.Rowspan = 0; // Default Rowspan for all items

            if (item.ParentSeminarID !== null) {
                // Increment child count for the parent
                parentChildMap[item.ParentSeminarID] = (parentChildMap[item.ParentSeminarID] || 0) + 1;
            }
        });

        // Assign Rowspan to parent seminars
        data.forEach(item => {
            if (item.ParentSeminarID === null) {
                // If it's a parent, Rowspan is itself plus its children
                item.Rowspan = (parentChildMap[item.SeminarID] || 0) + 1;
            }
        });

        return data;
    }

    getBadgeList() {
        const { SeminarList } = this.state
        this.setState({ isLoading: true })
        this.props.getExhSeminarBadgeList_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        // const result = SeminarList.map(item => ({
                        //     ...item,
                        //     IsSelect: data.data.some(item2 => item2.SeminarID === item.SeminarID) ? 1 : 0,

                        // }))
                        // console.log("result----->", result)
                        this.setState({ badgeList: data.data[1] });

                    }
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getExhibitorSeminarDetails() {
        const { SeminarList } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitorSeminarDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        // SeminarList.map(item => {
                        //     item.selectedBadges = []
                        // })
                        SeminarList.map(item => {
                            data.data.map(item2 => {
                                if (item2.SeminarID === item.SeminarID) {
                                    if (item2.ExhBadgesFormID != '' && item2.ExhBadgesFormID != null) {
                                        item.selectedBadges = item2.ExhBadgesFormID.split(',')
                                    } else {
                                        item.selectedBadges = []
                                    }
                                }
                            })
                        })
                        const result = SeminarList.map(item => ({
                            ...item,
                            IsSelect: data.data.some(item2 => item2.SeminarID === item.SeminarID) ? 1 : 0,

                        }))

                        console.log("result----->", result, data.data)
                        this.setState({ SeminarList: result });

                    }
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateExhibitorSeminar() {
        const { SeminarList } = this.state
        const array = []
        SeminarList.map(data => {
            if (data.selectedBadges) {
                if (data.selectedBadges.length > 0) {
                    data.selectedBadges.map(data2 => {
                        array.push({ SeminarID: data.SeminarID, ExhBadgesFormID: data2 })
                    })
                }
            }

            if (data.IsSelect) {
            }
        })
        this.setState({ isLoading: true })
        this.props.insertUpdateExhibitorSeminar_action(array)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Data Updated Successfully!")
                    this.getExhibitorSeminarDetails()
                    this.setState({ isLoading: false, badgeModalOpen: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // onCheked(event, index) {

    //     const { SeminarList } = this.state
    //     SeminarList.forEach((data, i) => {
    //         if (i === index) {
    //             data.IsSelect = event
    //         }
    //     })
    //     this.setState({ SeminarList: SeminarList })
    // }

    // On Checked seminar
    onCheckedSeminar(e, id) {
        const { SeminarList } = this.state
        const checked = e.target.checked
        // if (checked != undefined) {
        //     SeminarList.length > 0 && SeminarList.map((data) => {
        //         if (data.SeminarID == id) {
        //             if (checked) {
        //                 data.isSelect = true
        //             } else {
        //                 data.isSelect = false
        //             }
        //         }
        //     })
        // } else {
        //     SeminarList.length > 0 && SeminarList.map((data) => {
        //         if (data.SeminarID == id) {
        //             if (data.isSelect) {
        //                 data.isSelect = false
        //             } else {
        //                 data.isSelect = true
        //             }
        //         }
        //     })
        // }
        console.log("aaaaaaaaaaa", e.target.checked, SeminarList)
        this.setState({ SeminarList: SeminarList })
    }

    checkSelect(id) {
        const { isLoading, SeminarList, seminarId, badgeList, badgeModalOpen, isOpenConfirmationModal } = this.state
        var flag = false
        for (var i = 0; i < SeminarList.length; i++) {
            if (SeminarList[i].SeminarID == seminarId) {
                if (SeminarList[i].selectedBadges) {
                    console.log(id, SeminarList[i].selectedBadges)
                    if (SeminarList[i].selectedBadges.includes(`${id}`)) {
                        flag = true
                    }
                }
            }
        }
        return flag
    }

    checkedBoxClick(id) {
        const { isLoading, SeminarList, seminarId, badgeList, badgeModalOpen, isOpenConfirmationModal } = this.state
        for (var i = 0; i < SeminarList.length; i++) {
            if (SeminarList[i].SeminarID == seminarId) {
                if (SeminarList[i].selectedBadges) {
                    if (SeminarList[i].selectedBadges.includes(id)) {
                        var index = ''
                        for (var j = 0; j < SeminarList[i].selectedBadges.length; j++) {
                            if (SeminarList[i].selectedBadges[j] == id) {
                                index = j
                            }
                        }
                        SeminarList[i].selectedBadges.splice(index, 1)
                    } else {
                        SeminarList[i].selectedBadges.push(id)
                    }
                } else {
                    SeminarList[i].selectedBadges = [id]
                    // for (var j = 0; j < badgeList.length; j++) {
                    // }
                }
            }
        }
        this.setState({ SeminarList: SeminarList })
    }

    renderBadgeList() {
        const { isLoading, SeminarList, badgeList, badgeModalOpen, isOpenConfirmationModal } = this.state
        return (
            <div className="table-responsive">
                <table class="table border table-bordered mb-0">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Company Name</th>
                            <th>Designation</th>
                            <th>Person</th>
                            <th>Country</th>
                            <th>Email</th>
                            <th>Mobile</th>
                        </tr>

                    </thead>
                    <tbody>
                        {
                            badgeList.length > 0 ? <>{
                                badgeList.map((data, i) => (
                                    <tr onClick={(e) => this.checkedBoxClick(`${data.ExhBadgesFormID}`)}>
                                        <td class="text-center"> <input type="checkbox"
                                            checked={this.checkSelect(data.ExhBadgesFormID)}
                                            class="" name=""
                                        /> </td>
                                        <td >{data.CompanyName}</td>
                                        <td >{data.Designation}</td>
                                        <td >{data.Name}</td>
                                        <td >{data.CountryName}</td>
                                        <td >{data.Email}</td>
                                        <td >{data.MobileNo}</td>
                                    </tr>
                                ))}
                            </> :
                                <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                        }
                    </tbody>
                </table>
            </div>
        )

    }

    render() {
        const { isLoading, SeminarList, badgeList, badgeModalOpen, isOpenConfirmationModal } = this.state
        console.log(SeminarList)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content with-dr-container" style={{ marginTop: '3rem' }}>
                    <div className="">
                        <div className="">
                            <ExhibitorTopMenu />
                        </div>
                        <div className="row" style={{ marginLeft: '0.3rem' }}>
                            <div className="col-xl-12 p-0">
                                <div className="card rounded-0 border shadow-none">
                                    <div className="card-header p-2">
                                        <h3 className="card-title">Conference Session</h3>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="table-responsive" >
                                            <table className="table border table-bordered mb-0 mt-1" >
                                                <thead>
                                                    <tr>
                                                        <th className="text-center" style={{ width: '100px' }}>Day</th>
                                                        <th style={{ width: '200px' }} className="text-center">Register</th>
                                                        <th style={{ width: '350px' }}>Date & Time</th>
                                                        <th >Session Name</th>
                                                        {/* <th style={{ width: '400px' }}>Description</th>
                                                                                                <th style={{ width: '400px' }}>Speaker</th> */}
                                                        {/* <th style={{ width: '250px' }} className="text-center">Info</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        SeminarList.length > 0 && SeminarList.map((data) => (
                                                            <>
                                                                {/* {data.ParentSeminarID == 0 || data.ParentSeminarID == null && <tr >
                                                                                                            <td style={{ borderRight: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                            <td style={{ border: 'none' }}></td>
                                                                                                        </tr>} */}
                                                                {data.IsVisitor && <tr key={Math.random()}>
                                                                    {data.ParentSeminarID == 0 || data.ParentSeminarID == null ?
                                                                        <td className={"fw-bold"} rowSpan={data.Rowspan} style={{ verticalAlign: 'middle', textAlign: 'center' }}>{data.Day}</td>
                                                                        : <></>}
                                                                    <td className="text-center" style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                                        {data.ParentSeminarID != 0 && data.ParentSeminarID != null &&
                                                                            (data.SeminarTypeID == 2 ?
                                                                                <a
                                                                                    style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                    className="btn btn-aqua me-2"
                                                                                    // type="submit"
                                                                                    // onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                    onClick={(e) => this.setState({ badgeModalOpen: true, seminarId: data.SeminarID })}
                                                                                >
                                                                                    {data.selectedBadges ? data.selectedBadges.length > 0 ? "Withdraw Request" : "Request for Invite" : "Request for Invite"}
                                                                                </a>
                                                                                : data.SeminarTypeID == 3 ?
                                                                                    data.selectedBadges.length > 0 ?
                                                                                        <a
                                                                                            style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                            className="btn btn-aqua me-2"
                                                                                            // type="submit"
                                                                                            // onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                            onClick={(e) =>
                                                                                                this.setState({ badgeModalOpen: true, seminarId: data.SeminarID })
                                                                                                // })
                                                                                            }
                                                                                        >
                                                                                            Update Members
                                                                                        </a> :
                                                                                        <input
                                                                                            // style={{ marginTop: '12px' }}
                                                                                            type="checkbox"
                                                                                            checked={data.selectedBadges ? data.selectedBadges.length > 0 : false}
                                                                                            onChange={(e) =>
                                                                                                // this.setState({
                                                                                                //     ChargesPop: !data.isSelect ? true : false,
                                                                                                //     seminarCharges: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR - data.INRSGST - data.INRCGST) : (data.PriceINR - data.INRIGST) : data.PriceINR : data.IsGSTIncluded == 1 ? (data.PriceUSD - data.USDIGST) : data.PriceUSD,
                                                                                                //     seminarCGST: sessionStorage.getItem("countryId") == 91 ? data.INRCGST : 0,
                                                                                                //     seminarSGST: sessionStorage.getItem("countryId") == 91 ? data.INRSGST : 0,
                                                                                                //     seminarIGST: sessionStorage.getItem("countryId") == 91 ? data.INRIGST : data.USDIGST,
                                                                                                //     TotalPayable: sessionStorage.getItem("countryId") == 91 ? data.IsGSTIncluded == 1 ? data.PriceINR : data.INRCGST != 0 && data.INRSGST != 0 ? (data.PriceINR + data.INRSGST + data.INRCGST) : (data.PriceINR + data.INRIGST) : data.IsGSTIncluded == 1 ? data.PriceUSD : (data.PriceUSD + data.USDIGST),
                                                                                                // }, () => {
                                                                                                // this.onCheckedSeminar(e, data.SeminarID)
                                                                                                this.setState({ badgeModalOpen: true, seminarId: data.SeminarID })
                                                                                                // })
                                                                                            }
                                                                                        />
                                                                                    :
                                                                                    data.selectedBadges.length > 0 ?
                                                                                        <a
                                                                                            style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                                                                            className="btn btn-aqua me-2"
                                                                                            // type="submit"
                                                                                            // onClick={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                            onClick={(e) =>
                                                                                                this.setState({ badgeModalOpen: true, seminarId: data.SeminarID })
                                                                                                // })
                                                                                            }
                                                                                        >
                                                                                            Update Members
                                                                                        </a> :
                                                                                        <input type="checkbox"
                                                                                            // value={data.isSelect}
                                                                                            checked={data.selectedBadges ? data.selectedBadges.length > 0 : false}
                                                                                            // onChange={(e) => this.onCheckedSeminar(e, data.SeminarID)}
                                                                                            onChange={(e) => this.setState({ badgeModalOpen: true, seminarId: data.SeminarID })}
                                                                                        />)
                                                                        }
                                                                    </td>
                                                                    <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.DateTime}</td>
                                                                    <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}>{data.SessionName}{data.SeminarDetailsHtmlRef ? <>&nbsp;<span style={{ cursor: 'pointer' }} className="text-primary" onClick={() => {
                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                    }}>Click Here</span> to view more details.</> : ''}</td>
                                                                    {/* {data.ParentSeminarID != 0 && data.ParentSeminarID != null ?
                                                                                                                <> */}


                                                                    {/* <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Description}</td>
                                                                                                            {data.SeminarID != 14 ? (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker}</td>
                                                                                                            ) : (
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"}>{data.Speaker.split('==').map(item => (
                                                                                                                    <tr className="text-start">{item}</tr>
                                                                                                                ))}</td>
                                                                                                            )} */}


                                                                    {/* </> :
                                                                                                                <td className={data.ParentSeminarID != 0 && data.ParentSeminarID != null ? null : "fw-bold"} style={{ verticalAlign: 'middle', textAlign: 'center' }} colSpan={2}>{data.Description}</td>
                                                                                                                } */}

                                                                    {/* <td className="text-center">
                                                                                                                {data.SeminarDetailsHtmlRef != '' && data.SeminarDetailsHtmlRef != null ?
                                                                                                                    <span onClick={() => {
                                                                                                                        this.setState({ HTMLEDITOR: true, HtmlContent: data.SeminarDetailsHtmlRef })
                                                                                                                    }}>
                                                                                                                        <i class="bi bi-info-circle"></i>
                                                                                                                    </span> : <></>}
                                                                                                            </td> */}

                                                                </tr>}
                                                            </>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>

                                            <div />
                                        </div>
                                        {/* <button
                                            type="button"
                                            className="btn btn-aqua rounded-0 mt2"
                                            style={{ marginRight: 10, float: 'right', marginTop: '10px' }}
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                            // onClick={() => this.insertUpdateExhibitorSeminar()}
                                            disabled={SeminarList.length == 0}
                                        >
                                            Submit
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.badgeModalOpen} >
                    {/* onClick={() => this.props.navigate("/",)} */}
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            {badgeList.length > 0 ? <div className="modal-content estimate-details" style={{ maxWidth: '900px' }}>
                                <div className="modal-header p-2">
                                    <h5 className="modal-title text-white">
                                        Select the member to attend the session
                                    </h5>
                                </div>
                                <div className="modal-body p-2">
                                    {this.renderBadgeList()}
                                </div>
                                <div className="modal-footer pb-1 justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-aqua"
                                        data-bs-dismiss="modal"
                                        // onClick={(e) => this.submitContent()}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.setState({ badgeModalOpen: false })}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div> :
                                <div className="modal-content estimate-details" style={{ maxWidth: '800px' }}>
                                    <div className="modal-header p-2" style={{ textAlign: 'center' }}>
                                        <h5 className="modal-title text-white text-center p-2" >
                                            To attend Seminar kindly fill the exhibitor badge form first
                                        </h5>
                                    </div>
                                    {/* <div className="modal-body p-2">

                                    </div> */}
                                    <div className="modal-footer pb-1">
                                        {/* <button
                                            type="button"
                                            className="btn btn-aqua"
                                            data-bs-dismiss="modal"
                                            // onClick={(e) => this.submitContent()}
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                                        >
                                            Submit
                                        </button> */}
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            data-bs-dismiss="modal"
                                            onClick={(e) => this.setState({ badgeModalOpen: false })}
                                        >
                                            OK
                                        </button>
                                    </div>
                                </div>}
                        </div>

                    </div>

                    {/* </div> */}
                </Modal>
                <Modal isOpen={this.state.HTMLEDITOR} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                {/* <h5 class="modal-title modal_title_text text-Primary">
                                </h5> */}
                            </div>
                            <div class="modal-body">
                                <ul className="p-0">
                                    <li dangerouslySetInnerHTML={{ __html: `${this.state.HtmlContent != null ? this.state.HtmlContent : ''}` }}></li>
                                </ul>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            // this.togglePGCharges(2)
                                            this.setState({
                                                HTMLEDITOR: false,
                                            })
                                        }
                                        }
                                    >Ok</button>
                                    {/* <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignVisitorPop: false })}
                                    >Close</button> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getExhibitorSeminarDetails_action, getExhSeminarBadgeList_action, insertUpdateExhibitorSeminar_action })(ExhibitorSeminar))